import { n__, s__ } from '~/locale';
import MetadataItem from '~/vue_shared/components/registry/metadata_item.vue';
import TitleArea from '~/vue_shared/components/registry/title_area.vue';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'PackageTitle',
    components: {
        MetadataItem,
        TitleArea
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        count: {
            type: Number,
            required: false,
            default: null
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        showPackageCount () {
            return Number.isInteger(this.count);
        },
        packageCountText () {
            return n__('PackageRegistry|%d package', 'PackageRegistry|%d packages', this.count);
        }
    },
    i18n: {
        LIST_TITLE_TEXT: s__('PackageRegistry|Package registry')
    }
};
